"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const token_parser_1 = require("../token-parser");
const token_1 = require("../token");
const node_1 = require("../node");
const syntax_1 = require("../error/syntax");
const block_1 = require("../node/block");
const print_1 = require("../node/print");
const block_reference_1 = require("../node/block-reference");
/**
 * Marks a section of a template as being reusable.
 *
 * <pre>
 *  {% block head %}
 *    <link rel="stylesheet" href="style.css" />
 *    <title>{% block title %}{% endblock %} - My Webpage</title>
 *  {% endblock %}
 * </pre>
 */
const varValidator = require('var-validator');
class TwingTokenParserBlock extends token_parser_1.TwingTokenParser {
    parse(token) {
        let lineno = token.getLine();
        let columnno = token.getColumn();
        let stream = this.parser.getStream();
        let name = stream.expect(token_1.TwingToken.NAME_TYPE).getValue();
        let safeName = name;
        if (!varValidator.isValid(name)) {
            safeName = Buffer.from(name).toString('hex');
        }
        if (this.parser.hasBlock(name)) {
            throw new syntax_1.TwingErrorSyntax(`The block '${name}' has already been defined line ${this.parser.getBlock(name).getTemplateLine()}.`, stream.getCurrent().getLine(), stream.getSourceContext());
        }
        let block = new block_1.TwingNodeBlock(safeName, new node_1.TwingNode(new Map()), lineno, columnno);
        this.parser.setBlock(name, block);
        this.parser.pushLocalScope();
        this.parser.pushBlockStack(name);
        let body;
        if (stream.nextIf(token_1.TwingToken.BLOCK_END_TYPE)) {
            body = this.parser.subparse([this, this.decideBlockEnd], true);
            let token = stream.nextIf(token_1.TwingToken.NAME_TYPE);
            if (token) {
                let value = token.getValue();
                if (value != name) {
                    throw new syntax_1.TwingErrorSyntax(`Expected endblock for block "${name}" (but "${value}" given).`, stream.getCurrent().getLine(), stream.getSourceContext());
                }
            }
        }
        else {
            let nodes = new Map();
            nodes.set(0, new print_1.TwingNodePrint(this.parser.getExpressionParser().parseExpression(), lineno, columnno));
            body = new node_1.TwingNode(nodes);
        }
        stream.expect(token_1.TwingToken.BLOCK_END_TYPE);
        block.setNode('body', body);
        this.parser.popBlockStack();
        this.parser.popLocalScope();
        return new block_reference_1.TwingNodeBlockReference(name, lineno, columnno, this.getTag());
    }
    decideBlockEnd(token) {
        return token.test(token_1.TwingToken.NAME_TYPE, 'endblock');
    }
    getTag() {
        return 'block';
    }
}
exports.TwingTokenParserBlock = TwingTokenParserBlock;
